import { MuiButton } from './Button';
import { MuiInputBase } from './InputBase';
import { MuiTypography } from './Typography';

export const OverridesComponents: any = {
  MuiTypography,
  MuiInputBase,
  MuiButton,
};
